import type {
  ConfigurationResourceReadV2Api,
  ConfigurationResourceWriteV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { UpdateConfigurationFront } from '@ingenico/react-configuration-generator';
import { isEmpty, toString } from 'lodash-es';

/**
 * The PUT endpoint replaces the whole resource: every field omitted from the body is cleared.
 * The configuration form only owns name, description and definition, so the fields it does not
 * handle are carried over from the current resource.
 */
export function mapConfigurationPutBody(
  currentConfiguration: ConfigurationResourceReadV2Api,
  update: UpdateConfigurationFront,
): ConfigurationResourceWriteV2Api {
  const configuration = update.definition.configuration;

  return {
    name: toString(update.name || currentConfiguration.name),
    ...((update.description ?? currentConfiguration.description)
      ? { description: toString(update.description ?? currentConfiguration.description) }
      : {}),
    ...(currentConfiguration.deploymentPriority ? { deploymentPriority: currentConfiguration.deploymentPriority } : {}),
    definition: {
      compositions: update.definition.compositions.map(({ configurationId }) => ({ configurationId })),
      ...(configuration
        ? {
            configuration: {
              applicationVersions: configuration.applicationVersions.map(({ id, order, type }) => ({
                id,
                order,
                type,
              })),
              systemPackageVersions: configuration.systemPackageVersions.map(({ id, order, type }) => ({
                id,
                order,
                type,
              })),
              ...(configuration.osVersion ? { osVersion: { id: configuration.osVersion.id } } : {}),
              ...(isEmpty(configuration.remoteKeyInjection)
                ? {}
                : { remoteKeyInjection: configuration.remoteKeyInjection }),
            },
          }
        : {}),
    },
  } as ConfigurationResourceWriteV2Api;
}
